/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ImageModelView from '../../../../common/components/ImageViewer/ImageModelView';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  attachmentUrl: any;
}

const DownloadDocPresenter = ({
  isModalOpen,
  closeModal,
  attachmentUrl,
}: ModalProps) => {
  return (
    <ImageModelView
      url={attachmentUrl}
      isOpen={isModalOpen}
      onClose={closeModal}
      isAttachmentSigned={true}
    />
  );
};
export default DownloadDocPresenter;
